import IconWrapper, {
  IconWrapperProps,
} from "@repo/ui/src/components/IconWrapper";

const SelectedCheckboxIcon = (props: IconWrapperProps) => (
  <IconWrapper viewBox="0 0 24 24" width="24" height="24" {...props}>
    <rect width="24" height="24" fill="#B84308" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.6894 7.37422C17.218 6.87526 18.075 6.87526 18.6036 7.37422C19.0944 7.83755 19.1294 8.56819 18.7087 9.0697L18.6036 9.18114L10.717 16.6258C10.2262 17.0891 9.45218 17.1222 8.9209 16.7251L8.80285 16.6258L5.39644 13.4102C4.86785 12.9113 4.86785 12.1023 5.39644 11.6033C5.88727 11.14 6.66127 11.1069 7.19255 11.504L7.31061 11.6033L9.759 13.9154L16.6894 7.37422Z"
      fill="white"
    />
  </IconWrapper>
);

export default SelectedCheckboxIcon;
